<template>
  <div>
    <div>
      <b-row no-gutters>
        <b-col>
          <EngagementNav></EngagementNav>
        </b-col>
      </b-row>
    </div>
    <!-- Start Revamp -->
    <div class="engagement-body px-5">
      <div id="shadow-wrapper" class="rounded bg-white px-3 position-relative">
        <b-row>
          <b-col class="pr-md-0 py-4">
            <div id="nav-wrapper" class="d-flex align-items-center">
              <span class="mr-3 d-inline-flex align-items-center">News <i class="ic-tooltip ml-2" id="help"></i></span>
              <b-button
                id="general-settings-button"
                class="bg-white border-0 d-inline-flex align-items-center mr-3 px-3"
                @click="$root.$emit('bv::show::modal', 'news-popup-general-settings')">
                <img src="@/assets/images/gear-primary.svg" alt="General Settings" class="mr-2"> General Settings
              </b-button>
              <b-button
                :class="['bg-transparent border-0 shadow-none', activeListType === 'saved' ? 'text-primary' : 'text-muted']"
                @click="setActiveListType('saved')">
                Saved
              </b-button>
              <b-button 
               :class="['bg-transparent border-0 shadow-none', activeListType === 'drafts' ? 'text-primary' : 'text-muted']"
                @click="setActiveListType('drafts')">
                Drafts
              </b-button>
              <!-- <b-button
                :class="['bg-transparent border-0 shadow-none', activeListType === 'archived' ? 'text-primary' : 'text-muted']"
                @click="setActiveListType('archived')">
                Archived
              </b-button> -->
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col id="news-wrapper" class="pr-md-0 bg-white rounded py-3">
            <template v-if="loading">
              <div class="p-5 text-muted text-center">Loading...</div>
            </template>
            <template v-else>
              <transition name="fade">
                <carousel
                  style="margin-left: 15px; margin-right: 30px;"
                  :per-page="4"
                  :mouse-drag="false"
                  :paginationEnabled="false"
                  :navigationEnabled="true">
                  <slide
                    v-for="(newsItem, index) in newsAndPopups"
                    :key="`news_item_${index}`"
                    class="mr-1 px-1">
                    <b-card class="h-100 border-0" body-class="p-0">
                      <div class="news-img-wrapper bg-white">
                        <img :src="newsItem.image" alt="newsItem.title" class="img-fluid">
                      </div>
                      <div class="news-details-wrapper p-3">
                        <h4>{{ newsItem.title }}</h4>
                        <p class="p-0 mb-0"><small class="text-capitalize">Type: {{ newsItem.type ? newsItem.type : "news" }}</small></p>
                        <p class="p-0 mb-0"><small class="text-capitalize">Last edited: {{ newsItem.updated_at }}</small></p>
                        <div class="news-action-wrapper d-flex align-items-center mt-4">
                          <div style="position: relative; top: 15px">
                            <switches
                              :value="!newsItem.is_draft"
                              theme="custom"
                              color="primary"
                              type-bold="true"
                              @input="triggerItemOff(newsItem.uuid)"
                              :emit-on-mount="false"
                              disabled
                            ></switches>
                          </div>
                          <b-button
                            class="bg-transparent ml-2 border-0 p-0 shadow-none"
                            @click="$router.push({
                              name: 'type' in newsItem ? 'engagementPopupDesign' : 'engagementNewsDesign',
                              params: {
                                uuid: newsItem.uuid,
                                type: 'type' in newsItem ? newsItem.type : null
                              }
                            })">
                            <img src="@/assets/images/u_edit-alt.svg" alt="Edit">
                          </b-button>
                          <b-button
                            class="bg-transparent ml-2 border-0 p-0 shadow-none"
                            @click="callDelete(newsItem.uuid, newsItem.title, 'type' in newsItem ? 'popup' : 'news')">
                            <img src="@/assets/images/u_trash-alt.svg" alt="Delete">
                          </b-button>
                        </div>
                      </div>
                    </b-card>
                  </slide>
                </carousel>
              </transition>
            </template>
          </b-col>
        </b-row>
        <transition name="fade">
          <div
            id="confirm-archive"
            class="rounded position-absolute bg-white p-3 d-flex align-items-center"
            v-if="moveToArchive.show">
            <img src="@/assets/images/warning.svg" alt="Confirm Archive" class="mr-2">
            <p class="mb-0">Are you sure you want to move this to archive?</p>
            <b-button
              class="bg-transparent border-0 shadow-none text-primary"
              @click="confirmArchive">
              <b>Yes</b>
            </b-button>
            <b-button
              class="bg-transparent border-0 shadow-none text-muted"
              @click="cancelArchive">
              <b>Cancel</b>
            </b-button>
          </div>
        </transition>
        <b-button
          variant="primary"
          id="add-item"
          class="position-absolute rounded-circle"
          @click="$root.$emit('bv::show::modal', 'new-news-popup')">
          <img src="@/assets/images/plus-icon.svg" alt="Add">
        </b-button>
      </div>
    </div>
    <GeneralSettings />
    <NewNewsAndPopUp />
    <ConfirmDeleteNewsItem :newsDetail="deleteItem" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import Switches from "vue-switches";
import { Carousel, Slide } from "vue-carousel";
import EngagementNav from "./EngagementNav.vue";
import GeneralSettings from "./modals/GeneralSettings";
import NewNewsAndPopUp from "./modals/NewNewsAndPopUp";
import ConfirmDeleteNewsItem from "./modals/ConfirmDeleteNewsItem";

export default {
    name: "NewsAndPopUp",
    components: {
      Carousel,
      Slide,
      EngagementNav,
      Switches,
      GeneralSettings,
      NewNewsAndPopUp,
      ConfirmDeleteNewsItem
    },
    data() {
      return {
        moveToArchive: {
          show: false,
          uuid: null
        },
        deleteItem: {
          name: null,
          uuid: null,
          type: null
        },
      }
    },
    computed: {
      ...mapGetters({
        loading: "designs/loading",
        newsAndPopups: "designs/newsAndPopups",
        activeListType: "designs/activeListType"
      })
    },
    created() {
      // this.getNews(1);
      this.getNewsPopUp(this.activeListType);
    },
    mounted() {
      this.$root.$on("fetch-news-and-popup", () => {
        this.getNewsPopUp(this.activeListType);
      });
    },
    beforeDestroy() {
      this.$root.$off("fetch-news-and-popup");
    },
    watch: {
      activeListType(type) {
        this.getNewsPopUp(type);
      }
    },
    methods: {
      ...mapActions({
        getNewsPopUp: "designs/getNewsPopUp"
      }),
      ...mapMutations({
        setActiveListType: "designs/setActiveListType"
      }),
      async getNews(page) {
        await this.$store.dispatch("news/getNews", page);
      },
      paginate(page) {
        if (this.searching) {
          return this.search(false, page);
        }

        return this.getNews(page);
      },
      triggerItemOff(uuid) {
        this.moveToArchive = {
          show: false,
          uuid: null
        }; // Always Reset First
        const newsItemIsEnabled = this.newsAndPopups.find(item => item.uuid === uuid).is_draft;
        this.newsAndPopups.find(item => item.uuid === uuid).is_draft = false;
        if (!newsItemIsEnabled) {
          this.moveToArchive = {
            show: true,
            uuid: uuid
          };
        } else {
          console.log(`Enable this Item with UUID: ${uuid}`);
        }
      },
      confirmArchive() {
        console.log(`Archive this Item with UUID: ${this.moveToArchive.uuid}`);
        this.newsAndPopups.find(item => item.uuid === this.moveToArchive.uuid).is_draft = true;
        this.$nextTick(() => {
          this.moveToArchive = {
            show: false,
            uuid: null
          };
        });
      },
      cancelArchive() {
        this.newsAndPopups.find(item => item.uuid === this.moveToArchive.uuid).is_draft = false;
        this.$nextTick(() => {
          this.moveToArchive = {
            show: false,
            uuid: null
          };
        });
      },
      callDelete(uuid, title, type) {
        this.deleteItem = {
          name: title,
          uuid: uuid,
          type: type
        };
        this.$root.$emit("bv::show::modal", "news-delete-modal");
      }
    }
};
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Mulish:wght@400;500;700&display=swap');
.engagement-body {
  font-family: MainFontRegular, sans-serif;
  #shadow-wrapper {
    box-shadow: 0px 0px 11px #D5D8DC;
    min-height: 700px;
  }
}
#nav-wrapper {
  color: #2F3941;
  .btn {
    font-family: MainFontBold, sans-serif;
    font-weight: normal;
    &#general-settings-button {
      color: #2F3941;
      border-radius: 36px;
      box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    }
    &.text-muted {
      color: #87929D !important;
    }
  }
}
#news-wrapper {
  .row {
    overflow-x: auto;
  }
  .card {
    background-color: #F8F8F9;
    overflow: hidden;
  }
  .news-img-wrapper {
    height: 200px;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .news-details-wrapper {
    h4 {
      font-size: 14px;
      font-family: MainFontBold, sans-serif;
      font-weight: normal;
      color: #2F3941;
    }
    p {
      color: #87929D;
      font-size: 12px;
    }
  }
}
#confirm-archive {
  border: 1px solid #FFD231;
  bottom: 30px;
}
#add-item {
  bottom: 32px;
  right: 40px;
  width: 56px;
  height: 56px;
  box-shadow: 0px 15px 40px rgba(178, 186, 202, 0.7);
}
</style>
